import { useContext, useState } from 'react';
import { Button } from 'foundations-components/transitional/components/Button';
import FormattedMessage from 'I18n/components/FormattedHTMLMessage';
// @ts-expect-error Untyped dependency
import { get as isUnified } from 'reporting-data/retrieve/unified/supported';
import { shouldUseJourneyExportToList } from 'reporting-snowflake/funnel/utils/shouldUseJourneyExportToList';
import { getDataType, getReportDimensions } from 'reporting-data/report/reportGetters';
import { isConfigReport, isCustomWidgetReport } from 'reporting-data/tsTypes/reportTypes';
import { journeysExportToList } from 'reporting-snowflake/funnel/enhance/export/list';
import { ExportToListModal } from './ExportToListModal/ExportToListModal';
import exportUnifiedList from 'reporting-data/retrieve/unified/exportList';
import exportCRMList from 'reporting-data/retrieve/inboundDb/exportList';
import { COMPANIES, CONTACTS, DEALS, TICKETS, PARTNER_CLIENT } from 'reporting-data/constants/dataTypes';
import { getOrConvertToObjectTypeId } from 'reporting-data/crmObjects/tsUtils';
// @ts-expect-error Untyped dependency
import { ALLOWLISTED_HUBSPOT_DEFINED_CRM_OBJECTS } from 'reporting-data/crmObjects/utils';
// @ts-expect-error Untyped dependency
import { isCustomObjectType } from 'reporting-data/lib/customObjects';
import { UserInfoContext } from 'reporting-data/userInfo/userInfoContext';
import { DEAL_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { CRM_DEAL_LIST_CREATION } from 'reporting-data/constants/gates';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const VALID_OBJECT_TYPES = [CONTACTS, COMPANIES, DEALS, TICKETS, PARTNER_CLIENT].map(dataType => ALLOWLISTED_HUBSPOT_DEFINED_CRM_OBJECTS.get(dataType));
const getOnExportHandler = (report, gates) => {
  if (isCustomWidgetReport(report)) {
    return null;
  }
  if (shouldUseJourneyExportToList(report)) {
    return journeysExportToList;
  } else if (isUnified(getDataType(report)) && getReportDimensions(report).includes('people')) {
    return exportUnifiedList;
  } else if (isConfigReport(report)) {
    const objectTypeId = getOrConvertToObjectTypeId(report.get('config'));
    if (objectTypeId === DEAL_TYPE_ID && !gates.includes(CRM_DEAL_LIST_CREATION)) {
      return null;
    }
    if (VALID_OBJECT_TYPES.includes(objectTypeId) || isCustomObjectType(objectTypeId)) return exportCRMList;
  }
  return null;
};
function ListExportButton({
  onClick
}) {
  return /*#__PURE__*/_jsx(Button, {
    use: "tertiary-light",
    size: "small",
    onClick: onClick,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "reporting-ui-components.drilldownViewer.exportListButton"
    })
  });
}
export function ExportToListButton({
  report,
  onExportListClick: listClickOverride,
  onExportListSubmit: listSubmitOverride,
  extraInfo
}) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const {
    gates
  } = useContext(UserInfoContext);
  if (listClickOverride) {
    return /*#__PURE__*/_jsx(ListExportButton, {
      onClick: listClickOverride
    });
  }
  const onButtonClick = () => setIsModalOpen(true);
  const onExportSubmit = listSubmitOverride || getOnExportHandler(report, gates);
  if (!onExportSubmit) {
    return null;
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [isModalOpen && /*#__PURE__*/_jsx(ExportToListModal, {
      report: report,
      setModalOpen: setIsModalOpen,
      onSubmit: onExportSubmit,
      extraInfo: extraInfo
    }), /*#__PURE__*/_jsx(ListExportButton, {
      onClick: onButtonClick
    })]
  });
}